import { ISelectInputOption } from '@rocketmakers/armstrong';

export const enumToArray = <T, V extends string>(e: T, hasNumValue?: boolean, ...pick: V[]) => {
  const enumArray = Object.values(e).filter(value => pick.length === 0 || pick.includes(value));

  return hasNumValue ? enumArray.filter(value => typeof value === 'number') : enumArray;
};

export const generateSelectOptions = <T, V extends string>(
  e: T,
  hasNumValue?: boolean,
  ...pick: V[]
): ISelectInputOption[] => {
  return enumToArray(e, hasNumValue, ...pick).map(v => ({ id: v, name: v, data: v }));
};
